import PropTypes from 'prop-types';

import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import { srcOrNextImageProp } from 'PropTypes/imageProps';

import InformationList from './InformationList';
import TextOverBackgroundImage from './TextOverBackgroundImage';

const Wrapper = styled.div`
  background-color: ${theme.colors.neutral[200]};
`;

const CarbonFootprintBlock = ({ content }) => (
  <Wrapper>
    <InformationList list={content.carbon.list} title={content.carbon.title} />
    <TextOverBackgroundImage
      description={content.metricTonnes.description}
      images={content.metricTonnes.images}
      title={content.metricTonnes.title}
    />
    <InformationList list={content.supplyChain.list} title={content.supplyChain.title} />
  </Wrapper>
);

CarbonFootprintBlock.propTypes = {
  content: PropTypes.shape({
    metricTonnes: PropTypes.shape({
      images: PropTypes.shape({ mobile: srcOrNextImageProp, desktop: srcOrNextImageProp }),
      title: PropTypes.string,
      description: PropTypes.string,
    }),
    carbon: PropTypes.shape({
      title: PropTypes.string,
      list: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          description: PropTypes.string,
          icon: srcOrNextImageProp,
        })
      ),
    }),
    supplyChain: PropTypes.shape({
      title: PropTypes.string,
      list: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          description: PropTypes.string,
          icon: srcOrNextImageProp,
        })
      ),
    }),
  }).isRequired,
};

export default CarbonFootprintBlock;
